import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadTooltip from '@radix-ui/react-tooltip';
import { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
export const Tooltip = ({ content, children, align = 'center', side = 'top', sideOffset = 5, alignOffset = 0, onOpenChange, animationDurationMs, ...props }) => {
    const variables = useMemo(() => animationDurationMs
        ? {
            '--tooltip-animation-duration': `${animationDurationMs}ms`,
        }
        : undefined, [animationDurationMs]);
    if (!content) {
        return children;
    }
    return (_jsxs(Root, { onOpenChange: onOpenChange, delayDuration: 100, 
        // See: https://github.com/radix-ui/primitives/issues/2372
        disableHoverableContent: true, ...props, children: [_jsx(RadTooltip.Trigger, { asChild: true, onFocus: (event) => {
                    if (!event.currentTarget.matches(':focus-visible')) {
                        event.preventDefault();
                    }
                }, children: children }), _jsx(RadTooltip.Portal, { children: _jsx(Content, { style: variables, sticky: "always", sideOffset: sideOffset, alignOffset: alignOffset, side: side, align: align, className: props.className, children: content }) })] }));
};
const Root = styled(RadTooltip.Root) ``;
const slideDownAndFade = keyframes `
	from {
		opacity: var(--tooltip-opacity-from);
		transform: translateY(-2px);
    scale: var(--tooltip-scale-from);
	}
	to {
		opacity: 1;
		transform: translateY(0);
    scale: 1;
	}
`;
const slideUpAndFade = keyframes `
	from {
		opacity: var(--tooltip-opacity-from);
		transform: translateY(2px);
    scale: var(--tooltip-scale-from);
	}
	to {
		opacity: 1;
		transform: translateY(0);
    scale: 1;
	}
`;
const slideRightAndFade = keyframes `
	from {
		opacity: var(--tooltip-opacity-from);
		transform: translateX(-2px);
    scale: var(--tooltip-scale-from);
	}
	to {
		opacity: 1;
		transform: translateX(0);
    scale: 1;
	}
`;
const slideLeftAndFade = keyframes `
	from {
    opacity: var(--tooltip-opacity-from);
		transform: translateX(2px);
    scale: var(--tooltip-scale-from);
	}
	to {
		opacity: 1;
		transform: translateX(0);
    scale: 1;
	}
`;
const Content = styled(RadTooltip.Content) `
  --tooltip-scale-from: 0.8;
  --tooltip-opacity-from: 0.8;
  --tooltip-animation-duration: 50ms;
  --background: var(--tooltip-background, var(--background-3));
  --border-color: var(--tooltip-border-color, var(--background-3));
  --radius: var(--tooltip-border-radius, 8px);
  --padding: var(--tooltip-padding, 8px 10px 6px);

  background: var(--background);
  border: 0.5px solid var(--border-color);
  color: var(--text-12);

  border-radius: var(--radius);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  padding: var(--padding);

  box-shadow:
    hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;

  user-select: none;
  animation-duration: var(--tooltip-animation-duration);
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;

  &[data-state='delayed-open'][data-side='top'],
  &[data-state='instant-open'][data-side='top'] {
    animation-name: ${slideDownAndFade};
  }
  &[data-state='delayed-open'][data-side='right'],
  &[data-state='instant-open'][data-side='right'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-state='delayed-open'][data-side='bottom'],
  &[data-state='instant-open'][data-side='bottom'] {
    animation-name: ${slideUpAndFade};
  }
  &[data-state='delayed-open'][data-side='left'],
  &[data-state='instant-open'][data-side='left'] {
    animation-name: ${slideRightAndFade};
  }
`;
//# sourceMappingURL=tooltip.js.map